import { useMemo } from 'react'
import { CONFIG } from '../config'

// Split text into: redaction tokens | alphanumeric words | everything else
const SEGMENT_RE = new RegExp(
  `(${CONFIG.token.pattern.source}|[a-zA-Z0-9]+|[^a-zA-Z0-9]+)`,
  'g'
)

export function WordSpanRenderer({ text, onWordClick, className, style }) {
  const segments = useMemo(() => {
    if (!text) return []
    return [...text.matchAll(SEGMENT_RE)].map(([s]) => s)
  }, [text])

  return (
    <div className={className} style={style}>
      {segments.map((segment, i) => {
        // Redacted token — tap to restore
        if (CONFIG.token.patternExact.test(segment)) {
          return (
            <span
              key={i}
              onClick={() => onWordClick(segment)}
              className="bg-blue-200 dark:bg-blue-500/30 text-blue-900 dark:text-blue-200 rounded-sm cursor-pointer hover:bg-blue-300 dark:hover:bg-blue-400/40 active:bg-blue-400 dark:active:bg-blue-500/60 px-0.5 transition-colors"
            >
              {segment}
            </span>
          )
        }

        // Plain word — tap to redact
        if (/^[a-zA-Z0-9]+$/.test(segment)) {
          return (
            <span
              key={i}
              onClick={() => onWordClick(segment)}
              className="cursor-pointer rounded-sm hover:bg-amber-100 dark:hover:bg-amber-900/20 active:bg-amber-200 dark:active:bg-amber-800/40 transition-colors"
            >
              {segment}
            </span>
          )
        }

        // Whitespace and punctuation — render as-is, not interactive
        return <span key={i}>{segment}</span>
      })}
    </div>
  )
}
